import { render, staticRenderFns } from "./mainModuleDetails.vue?vue&type=template&id=8adca4c8&scoped=true"
import script from "./mainModuleDetails.vue?vue&type=script&lang=js"
export * from "./mainModuleDetails.vue?vue&type=script&lang=js"
import style0 from "./mainModuleDetails.vue?vue&type=style&index=0&id=8adca4c8&prod&lang=scss&scoped=true"
import style1 from "./mainModuleDetails.vue?vue&type=style&index=1&id=8adca4c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8adca4c8",
  null
  
)

export default component.exports